import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-close',
  templateUrl: './close.component.html',
})
export class CloseComponent implements OnInit {
  @Input() link: string;
  @Input() confirm: string;

  constructor(private location: Location, private router: Router) { }

  ngOnInit() {
  }

  // TODO: Location back if link attribute is empty.
  goTo() {
    if (this.link) {
      this.router.navigate([this.link]);
      return;
    }
    this.location.back();
  }
}
